
document.addEventListener('DOMContentLoaded', () => {
    // Select all elements with data-product-review-note attribute
    const ratingElements = document.querySelectorAll('[data-product-review-note]');

    ratingElements.forEach(element => {
        // Get the rating value (0 to 5)
        const rating = parseFloat(element.getAttribute('data-product-review-note'));

        // Find the SVG within this element
        const svg = element.querySelector('svg');
        if (!svg) return;

        // Get all star paths within the SVG
        const stars = svg.querySelectorAll('path');

        // Loop through each star and set fill color based on rating
        stars.forEach((star, index) => {
            if (index < Math.floor(rating)) {
                // Full star: keep original color (#E64601)
                star.setAttribute('fill', '#688B00');
            } else if (index === Math.floor(rating) && rating % 1 !== 0) {
                // Partial star: create a gradient for fractional rating
                const gradientId = `partial-star-${index}-${Date.now()}`;
                const gradient = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
                gradient.setAttribute('id', gradientId);
                gradient.innerHTML = `
                    <stop offset="${rating % 1 * 100}%" stop-color="#688B00"/>
                    <stop offset="${rating % 1 * 100}%" stop-color="#688B00"/>
                    `;
                svg.querySelector('defs') || svg.insertAdjacentHTML('afterbegin', '<defs></defs>');
                svg.querySelector('defs').appendChild(gradient);
                star.setAttribute('fill', `url(#${gradientId})`);
            } else {
                // Empty star: gray color
                star.setAttribute('fill', '#D3D3D3');
            }
        });
    });
});




(function () {
    const TARGET_FRACTION = 1 / 3; // 0.333...
    const els = document.querySelectorAll('.background--custom');

    const onIntersect = (entries, observer) => {
        const triggerY = window.innerHeight * TARGET_FRACTION;

        entries.forEach(entry => {
            // On ne dépend pas uniquement de isIntersecting : on vérifie la position
            const top = entry.boundingClientRect.top;

            if (entry.isIntersecting && top <= triggerY) {
                entry.target.classList.add('background--custom-active');
                observer.unobserve(entry.target); // active une fois
            }
        });
    };

    const observer = new IntersectionObserver(onIntersect, {
        root: null,
        threshold: [0] // déclenche dès qu'une fraction minimale entre dans le viewport
    });

    els.forEach(el => observer.observe(el));

    // Optionnel : si on redimensionne, on relance une passe sur les éléments restants
    window.addEventListener('resize', () => {
        document.querySelectorAll('.background--custom:not(.background--custom-active)')
            .forEach(el => {
                const rect = el.getBoundingClientRect();
                if (rect.top <= window.innerHeight * TARGET_FRACTION && rect.bottom >= 0) {
                    el.classList.add('background--custom-active');
                    observer.unobserve(el);
                }
            });
    });
})();

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);

        // Observe le switch d’onglet (uniq ↔ sub) via MutationObserver
        const variantsRoot = document.querySelector('.product-variants');
        if (variantsRoot) {
            this._mo = new MutationObserver(() => this.applySellingPlanFromUI());
            this._mo.observe(variantsRoot, { attributes: true, subtree: true, attributeFilter: ['class'] });
        }
    }

    /* ========= UTILITAIRES ABONNEMENT ========= */

    getPlanIds() {
        const root = document.querySelector('.product-variants');
        if (!root) return [];
        const csv = root.getAttribute('data-sp-ids') || '';
        return csv.split(',').map(s => s.trim()).filter(Boolean);
    }

    getSubWrapper() {
        const root = document.querySelector('.product-variants');
        if (!root) return null;
        return root.querySelector('.product-variants__wrapper[data-sub="true"]');
    }

    getActiveWrapper() {
        const root = document.querySelector('.product-variants');
        if (!root) return null;
        return root.querySelector('.product-variants__wrapper.active');
    }

    getValidSubLines() {
        const wrap = this.getSubWrapper();
        if (!wrap) return [];
        return Array.from(wrap.querySelectorAll('.product-variant-line:not(.product-variant-line--disabled)'))
            .filter(l => l.getAttribute('data-has-sp') === 'true');
    }

    getActiveSubIndex() {
        const lines = this.getValidSubLines();
        if (!lines.length) return -1;
        return lines.findIndex(l => l.classList.contains('product-variant-line--active'));
    }

    setSellingPlanByIndex(index) {
        const form = document.querySelector(`#product-form-${this.dataset.section}`);
        if (!form) return;

        const ids = this.getPlanIds();
        if (!ids.length) {
            // pas de plans → nettoyer
            const old = form.querySelector('input[name="selling_plan"]');
            if (old) old.remove();
            return;
        }

        const clamped = Math.min(Math.max(0, index), ids.length - 1);
        const id = ids[clamped];

        let input = form.querySelector('input[name="selling_plan"]');
        if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            form.appendChild(input);
        }
        input.value = id;
    }

    clearSellingPlan() {
        const form = document.querySelector(`#product-form-${this.dataset.section}`);
        if (!form) return;
        const input = form.querySelector('input[name="selling_plan"]');
        if (input) input.remove();
    }

    applySellingPlanFromUI() {
        // si pas de plan, rien à faire
        if (!this.getPlanIds().length) return;

        const activeWrapper = this.getActiveWrapper();
        const subWrapper = this.getSubWrapper();

        // pas sur l’onglet Abonnement → enlever selling_plan
        if (!activeWrapper || !subWrapper || !activeWrapper.isSameNode(subWrapper)) {
            this.clearSellingPlan();
            return;
        }

        // on est sur l’onglet Abonnement → mappe index visuel -> plan
        let idx = this.getActiveSubIndex();
        if (idx < 0) {
            // si aucune ligne active valide, prendre la 1ère valide
            const lines = this.getValidSubLines();
            idx = lines.length ? 0 : -1;
        }
        if (idx >= 0) this.setSellingPlanByIndex(idx);

        // sécurise le bouton si pas d’allocation pour la ligne active
        const form = document.querySelector(`#product-form-${this.dataset.section}`);
        const btn = form ? form.querySelector('[name="add"]') : null;
        if (btn) {
            const hasValidLine = this.getValidSubLines().length > 0;
            const canSell = !!(this.currentVariant && this.currentVariant.available) && hasValidLine;
            btn.disabled = !canSell;
            btn.classList.toggle('is-disabled', !canSell);
        }
    }

    /* ========== CŒUR EXISTANT ========== */

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();

        const isAvailable = !!(this.currentVariant && this.currentVariant.available);
        this.toggleAddButton(!isAvailable, isAvailable ? '' : window.variantStrings.soldOut, false);

        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            // this.renderProductInfo();
            this.updateAllPrices();
            this.updateShareUrl();

            // 🔗 applique/retire le selling_plan en fonction de l’onglet + index visuel
            this.applySellingPlanFromUI();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
        mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
        modalContent.prepend(newMediaModal);
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue)
        });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.innerText = input.getAttribute('value');
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;
        const productForm = section.querySelector('product-form');
        // if (productForm) productForm.handleErrorMessage();
    }

    updateAllPrices() {
        if (!this.currentVariant) return;

        const root = document.querySelector('.product-variants');
        if (!root) return;

        // ---- Récup config "diagnostic" depuis <product-template>
        const pt = document.querySelector('product-template');
        const diagEnabled = !!pt && /^(true|1)$/i.test(String(pt.getAttribute('data-resultat-enabled') || ''));
        const diagPct = diagEnabled ? parseInt(pt.getAttribute('data-resultat-reduction') || '0', 10) : 0;
        const clamp = (n) => (Number.isFinite(n) ? n : 0);
        const applyDiag = (cents) => {
            if (!diagEnabled || !diagPct) return clamp(cents);
            const factor = (100 - Math.max(0, diagPct)) / 100;
            return Math.max(0, Math.round(clamp(cents) * factor));
        };

        const centsToText = (cents) =>
            (clamp(cents) / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

        const baseCents = clamp(this.currentVariant.price);
        const compareCents = clamp(this.currentVariant.compare_at_price || 0);

        // ---- Header "Achat unique": appliquer la remise au prix courant
        const uniqHeaderPrice = root.querySelector('.product-variants__wrapper[data-sub="false"] .product-variants__price');
        if (uniqHeaderPrice) {
            const finalUniqCents = applyDiag(baseCents);
            uniqHeaderPrice.innerHTML =
                `${compareCents > baseCents ? `<s>${centsToText(compareCents)}</s>` : '<s></s>'}
       ${centsToText(finalUniqCents)}`;
        }

        // ---- Abonnement (on ne modifie PAS le prix abo ici, tu peux le changer si besoin)
        const subWrapper = root.querySelector('.product-variants__wrapper[data-sub="true"]');
        let subCents = null;

        if (subWrapper) {
            const line = subWrapper.querySelector(`.product-variant-line[data-variant-id="${this.currentVariant.id}"]`);
            if (line && line.dataset.subPriceCents) {
                const parsed = parseInt(line.dataset.subPriceCents, 10);
                if (!Number.isNaN(parsed)) subCents = parsed;
            } else {
                const node = subWrapper.querySelector(`.product-variant-line[data-variant-id="${this.currentVariant.id}"] .product-variant-line__price`);
                if (node) {
                    const m = (node.textContent || '').match(/(\d[\d\s\u00A0]*[.,]\d{2}|\d[\d\s\u00A0]*)/);
                    if (m) {
                        const euros = parseFloat(m[1].replace(/\s|\u00A0/g, '').replace(',', '.'));
                        if (!Number.isNaN(euros)) subCents = Math.round(euros * 100);
                    }
                }
            }

            const subHeaderPrice = subWrapper.querySelector('.product-variants__price');
            if (subHeaderPrice) {
                // affichage entête abonnement (inchangé)
                if (subCents != null) {
                    subHeaderPrice.innerHTML = `<s>${centsToText(baseCents)}</s> ${centsToText(subCents)}`;
                } else {
                    subHeaderPrice.innerHTML = `${centsToText(baseCents)}`;
                }
            }
        }

        // ---- Prix final utilisé pour le bouton & le message livraison
        const activeWrapper = root.querySelector('.product-variants__wrapper.active');
        const useSub = activeWrapper && activeWrapper.dataset.sub === 'true' && subCents != null;

        // 👉 remise appliquée UNIQUEMENT sur l’onglet Achat unique (conforme à ta demande “dans ce block-là”)
        const finalCents = useSub ? clamp(subCents) : applyDiag(baseCents);

        // bouton principal
        document.querySelectorAll('[data-current-final-price]').forEach((el) => {
            el.textContent = centsToText(finalCents);
            el.setAttribute('data-current-final-price', String(finalCents));
        });

        // ---- Message livraison vs seuil min_free_shipping
        const shippingSpan = document.querySelector('.product-form__shipping-text');
        if (pt && shippingSpan) {
            const thresholdEuros = Number(pt.getAttribute('data-min-free-shipping') || 0);
            const thresholdCents = Math.round(thresholdEuros * 100);

            const msgOk = shippingSpan.getAttribute('data-shipping-message-ok') || '';
            const msgMin = shippingSpan.getAttribute('data-shipping-message') || '';
            shippingSpan.textContent = finalCents < thresholdCents ? msgMin : msgOk;
        }
    }


    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');

        } else {
            addButton.removeAttribute('disabled');
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('visibility-hidden');
        if (inventory) inventory.classList.add('visibility-hidden');
        if (sku) sku.classList.add('visibility-hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() { super(); }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.classList.remove('disabled');
            } else {
                input.classList.add('disabled');
            }
        });
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        });
    }
}
customElements.define('variant-radios', VariantRadios);


class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        this.poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!this.poster) return;
        this.poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent() {
        window.pauseAllMedia?.();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            if (content.querySelector('video-section')) {
                this.appendChild(content).focus();
            } else {
                this.setAttribute('loaded', true);
                this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
            }
        }
    }
}
customElements.define('deferred-media', DeferredMedia);

document.addEventListener('DOMContentLoaded', () => {

    setTimeout(() => {
        document.querySelectorAll('.jdgm-rev-widg__title').forEach(el => {
            el.innerHTML = "la cure a changé <em class='background--custom'>leur quotidien.</em>";
        });
    }, 1000);

});